import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

// Axios Mock Adapter (dev only — vendor panel uses live API)
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  require('@/@fake-db/db')
}
import VueCountryCode from "vue-country-code";

Vue.use(VueCountryCode);
// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");
Vue.mixin({
  methods: {
    getOptions(name) {
      return this.$store.state.app[name] ?? [];
    },
    getAllStoreData() {},
  },
});
Vue.filter('trim',(value,length=50)=>{
  if (value && value.length > length) {
      return value.substring(0, length) + '...'
  }
  return value
})

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
